module.exports = __webpack_public_path__ + "img/202501_liftserum.0927fd9c.jpg";